import React from 'react';

export const loaderView = () => {
  return (
    <div className='loader logo-loader'>
      <svg
        width='50px'
        version='1.1'
        id='L4'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        x='0px'
        y='0px'
        viewBox='0 0 63 12'
        enableBackground='new 0 0 0 0'
        xmlSpace='preserve'
      >
        <circle fill='#3f51b5' stroke='none' cx='6' cy='6' r='6'>
          <animate
            attributeName='opacity'
            dur='1s'
            values='0;1;0'
            repeatCount='indefinite'
            begin='0.1'
          ></animate>
        </circle>
        <circle fill='#3f51b5' stroke='none' cx='31' cy='6' r='6'>
          <animate
            attributeName='opacity'
            dur='1s'
            values='0;1;0'
            repeatCount='indefinite'
            begin='0.2'
          ></animate>
        </circle>
        <circle fill='#3f51b5' stroke='none' cx='56' cy='6' r='6'>
          <animate
            attributeName='opacity'
            dur='1s'
            values='0;1;0'
            repeatCount='indefinite'
            begin='0.3'
          ></animate>
        </circle>
      </svg>
    </div>
  );
};
